// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 474 ? "fe69a73d" : chunkId) + "." + {"474":"a0a682b2a97b0318","5272":"f63a63a549d1ae43","6345":"69f1b084e645b262"}[chunkId] + ".js";
};